export var BREAKPOINTS = {
  tablet_vertical: 768,
  tablet_horizontal: 1024,
  desktop: 1200,
  desktop_large: 1600
};